<template>
  <g>
    <!-- پس‌زمینه آبی -->
    <rect x="0" y="0" width="42" height="42" rx="4" ry="4" fill="#0A66C2" />

    <!-- حرف i -->
    <path
      fill="#FFF"
      d="M8.64 17.28H12.48V33.6H8.64zM10.56 15.36c-1.44 0-2.4-1.12-2.4-2.4 0-1.28 1-2.4 2.4-2.4 1.44 0 2.4 1.12 2.4 2.4C12.96 14.24 12 15.36 10.56 15.36z"
    />

    <!-- حرف n -->
    <path
      fill="#FFF"
      d="M17.28 17.28h3.84v2.08c.64-1.12 2.16-2.4 4.48-2.4 3.84 0 6.72 2.88 6.72 7.84v8.8H28.48v-8.32c0-2.24-1.12-3.84-3.36-3.84-1.6 0-2.72 1.12-3.2 2.24-.16.32-.16 1.12-.16 1.6v8.32h-4.48V17.28z"
    />

    <!-- دایره CO -->
    <circle
      cx="33.2"
      cy="30.6"
      r="4.2"
      fill="none"
      stroke="#FFF"
      stroke-width="1.4"
    />

    <!-- حرف C داخل دایره -->
    <path
      fill="#FFF"
      d="M31.9 30.6c0-1.4.9-2.2 2.1-2.2.6 0 1 .1 1.5.4l-.3 1c-.3-.3-.7-.4-1.1-.4-.8 0-1.3.6-1.3 1.3 0 .8.5 1.3 1.3 1.3.4 0 .8-.1 1.1-.4l.3 1c-.4.2-.9.4-1.6.4-1.2 0-2.1-.8-2.1-2.2z"
    />

    <!-- حرف O داخل دایره -->
    <path
      fill="#FFF"
      d="M35.9 28.4c1.3 0 2.2.8 2.2 2.2 0 1.4-.9 2.2-2.2 2.2-1.3 0-2.2-.8-2.2-2.2 0-1.4.9-2.2 2.2-2.2zm0 3.4c.7 0 1.1-.6 1.1-1.3 0-.7-.4-1.3-1.1-1.3-.7 0-1.1.6-1.1 1.3 0 .7.4 1.3 1.1 1.3z"
    />
  </g>
</template>

<script>
export default {
  name: "svgLinkedinCo",
};
</script>

<style scoped></style>
